export const DEFAULT_NOTIFICATION_KEYS = {
  OFFLINE_MODE: 'offline_mode',
};

export const DEFAULT_NOTIFICATION_CONFIG = {
  [DEFAULT_NOTIFICATION_KEYS.OFFLINE_MODE]: {
    id: DEFAULT_NOTIFICATION_KEYS.OFFLINE_MODE,
  },
};
